module.exports = __webpack_public_path__ + "static/media/feature-interview-pass.9c1f285b.png";